import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext } from "react";

import MobileHome from "./MobileHome";
import WebHome from "./WebHome";

function ResponsiveHome() {
    const { isMobile } = useContext(BrowserDetectContext);
    return (
        <>
            {
                isMobile
                    ?
                    <MobileHome />
                    :
                    <WebHome />
            }
        </>
    );
}

export default ResponsiveHome;